import type { Game } from 'chessboard/model/game/types';
import type { Board } from 'model/board/types';
import { getEPCapturedSquare } from 'chessboard/model/move/get-ep-captured-square';

/**
 * Extend a move object by adding the rook's move if it's a castle,
 * and adding "animate" property if it's not a drop.
 */
export function extendMove(node: Game.Move.Node): Game.Move.ExtendedNode {
  const extended: Game.Move.ExtendedNode = {
    ...node,
    EPCapturedSquare: getEPCapturedSquare(node),
  };

  if (node.rookFrom && node.rookTo) {
    extended.rookMove = {
      animate: true,
      from: <Board.SanSquare>node.rookFrom,
      to: <Board.SanSquare>node.rookTo,
    };
  }

  return extended;
}
